@defer (when iframeSrc()) {
  <iframe width="100%" height="100%" allowscriptaccess="always" [src]="sanitizer.bypassSecurityTrustResourceUrl(iframeSrc())"></iframe>
} @placeholder {
  <app-please-wait />
}
